export default __webpack_public_path__ + "static/media/peep-47.ee6366cc.svg";